import { useState, useEffect } from 'react';
import '../../../Styles/Payment/Payment.css';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import { useTranslation } from 'react-i18next';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './PaymentForm';
import CouponModal from './CouponModal';
import axiosUserInstance from '../../../axiosUserInstance';
import { useLocation } from 'react-router-dom';
import BackButton from '../../../Components/BackButton';
import viewCouponImage from '../../../assets/svg/viewCouponImage.svg';
import RightArrow from '../../../assets/svg/RightArrow';
import { useCart } from '../../../CartProvider';
import whiteRound from '../../../assets/svg/whiteRound.svg';
import CouponCodeInput from './CouponCodeInput';
import { jwtDecode } from 'jwt-decode';
import CloseIcon from '../../../assets/svg/closeIcon';
import axiosPaymentInstance from '../../../axiosPaymentinstance';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function Payment() {
   
    const { t } = useTranslation();
    const location = useLocation();
    const selectedOption = location.state?.selectedOption || '';
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [selectedOfferPercentage, setSelectedOfferPercentage] = useState(null);
    const [selectedCouponAmount, setSelectedCouponAmount] = useState(null);
    const [couponID,setCouponID] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [couponsID, setCouponsID] = useState(null);
    const [offersID, setOffersID] = useState(null);
    const [vendorID,setVendorID] = useState(null);
    const [discountError, setDiscountError] = useState(false);
    const [taxOtherFees, setTaxOtherFees] = useState(false);
    const {offerModelPercentage,setOfferModelPercentage, selectedAddress, vendorAddress } = useCart();
    const cookingInstructionValue = location.state?.cookingInstructionValue || '';
    console.log(cookingInstructionValue,'cookingInstructionValue');
    const deliveryInstructionValue = JSON.stringify(location.state?.selectedInstructions) || '';
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('authToken');
    const decodedToken = jwtDecode(token);
    const [discountAmount,setDiscountAmount] = useState(0);
    const [showData, setShowData] = useState(false);
    
    useEffect(() => {
        if (!loading) {
            const timer = setTimeout(() => {
                setShowData(true);
            }, 1000);
            return () => clearTimeout(timer); // cleanup if loading changes again
        } else {
            setShowData(false); // reset to false when loading starts again
        }
    }, [loading]);

    const getTotalPrice = async () => {
        const location = JSON.parse(localStorage.getItem('selectedLocation'));

        const lat = location?.lat;
        const lng = location?.lng;
        try {
            const itemResponse = await axiosUserInstance.get('/cartdetails/cartsp', {
                params: {
                    latitude: lat,
                    longitude: lng,
                }
            });
            const data = itemResponse?.data?.cartDetails[0]?.Cart_Total_Price;
            setVendorID(itemResponse?.data?.cartDetails[0]?.Cart_Information[0]?.Vendor_Id);      
            setTotalPrice(data);
        } catch (error) {
            console.error('Error fetching total price:', error);
        }
    };
    
    useEffect(() => {
        getTotalPrice();

        if (offerModelPercentage) {
            setSelectedOffer(offerModelPercentage?.Title);
            setSelectedOfferPercentage(offerModelPercentage?.percentage);
            setOffersID(offerModelPercentage?.ID);
        }
    }, [offerModelPercentage]);

    // Calculate discount amount
    useEffect(() => {
        let discount = 0;

        if (selectedCouponAmount > 0) {
            discount = selectedCouponAmount;
        } else if (selectedOfferPercentage > 0) {
            discount = totalPrice * (selectedOfferPercentage / 100);
        }

        // Round and validate discount
        discount = parseFloat(discount.toFixed(2));

        if (discount > totalPrice) {
            setDiscountError(true);
            setSelectedCoupon(null);
            setSelectedOffer(null);
            setSelectedOfferPercentage(null);
            setSelectedCouponAmount(null);
            setOfferModelPercentage(null);
            setDiscountAmount(0);
        } else {
            setDiscountError(false);
            setDiscountAmount(discount);
        }
    }, [selectedOfferPercentage, selectedCouponAmount, totalPrice]);

    // Calculate tax whenever subtotal changes

    useEffect(() => {
        if (totalPrice <= 0) return;

        const calculateTax = async () => {
            const postalCode = localStorage.getItem('selectedPincode');
            const pickupAddressObj = JSON.parse(localStorage.getItem('vendorAddress'));

            const pickupAddress = [
                pickupAddressObj?.vendor_address,
                pickupAddressObj?.vendor_city?.trim(),
                pickupAddressObj?.vendor_state,
                pickupAddressObj?.vendor_country,
                pickupAddressObj?.vendor_postalcode
            ].filter(Boolean).join(', ');

            const deliveryFullAddress = localStorage.getItem('selectedCustomerAddress');
        
            let deliveryAddress = null;
            try {
                if (deliveryFullAddress) {
                    deliveryAddress = JSON.parse(deliveryFullAddress);
                }
            } catch (err) {
                console.warn('Invalid JSON in selectedCustomerAddress:', err);
            }

            if (selectedOption === 'delivery' && !deliveryAddress) {
                console.warn('Delivery option selected but deliveryAddress is missing or invalid.');
                return;
            }

            try {
                setLoading(true);
                const currentTime = new Date(Date.now() + 20 * 60000).toISOString();

                const shipdayPayload = {
                    subtotal: totalPrice,
                    selectedOption,
                    currency: 'usd',
                    vendorID: vendorID,
                    customerDetails: {
                        address: selectedOption === 'delivery' ? {
                            line1: deliveryAddress?.Address_line_1,
                            line2: deliveryAddress?.Address_line_2,
                            city: deliveryAddress?.City,
                            state: deliveryAddress?.State,
                            latitude: deliveryAddress?.Latitude,
                            longitude: deliveryAddress?.Longitude,
                            postalCode: postalCode,
                            country: 'US'
                        } : {
                            line1: pickupAddressObj?.vendor_address,
                            line2: '',
                            city: pickupAddressObj?.vendor_city,
                            state: pickupAddressObj?.vendor_state,
                            postalCode: pickupAddressObj?.vendor_postalcode,
                            country: 'US'
                        }
                    },
                    pickupAddress : selectedOption === 'delivery' ? '' : pickupAddress,
                    deliveryFullAddress: selectedOption === 'delivery' ? {
                        line1: deliveryAddress?.Address_line_1 || '',
                        line2: deliveryAddress?.Address_line_2 || '',
                        city: deliveryAddress?.City || '',
                        state: deliveryAddress?.State || '',
                        postalCode: postalCode,
                        country: 'US'
                    } : '',
                    deliveryTime: currentTime,
                    discountAmount
                };

                const res = await axiosPaymentInstance.post('/payment/calculateTaxAndDelivery', shipdayPayload, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setTaxOtherFees(res.data);

            } catch (error) {
                console.error('❌ Shipday or internal API error:', error);
                toast.error(error?.response?.data?.error || 'Unable to place the order at this time.');
            } finally {
                setLoading(false);
            }
        };
        calculateTax();
    }, [
        totalPrice,
        selectedOption,
        vendorAddress,
        discountAmount
    ]);


    const handleRemoveCoupon = (e) => {
        e.stopPropagation();
        setSelectedCoupon(null);
        setSelectedOffer(null);
        setSelectedOfferPercentage(null);
        setSelectedCouponAmount(null);
        setOfferModelPercentage(null);
    };

    const goBack = () => {
        window.history.back();
    };

    const fetchCoupons = async () => {
        try {
            const response = await axiosVendorInstance.get(`/vendor/coupon/vendor/${vendorID}?limit=50`);
            setCoupons(response?.data?.coupons);
        } catch (error) {
            console.error('Error fetching coupons:', error);
        }
    };

    useEffect(() => {
        (async () => {
            const id = await getTotalPrice();
            fetchCoupons(id);
        })();
    }, []);

    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const discountLabel = selectedCoupon ? 'Discount (Coupon)' : `Discount (${selectedOfferPercentage}%)`;                    

    return (
        <div>
            <Helmet>
                <title>{SEO.PAYMENT_PAGE.TITLE}</title>
                <meta name="description" content={SEO.PAYMENT_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.PAYMENT_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.PAYMENT_PAGE.CANONICAL} />
                                    
                <meta property="og:title" content={SEO.PAYMENT_PAGE.TITLE} />
                <meta property="og:description" content={SEO.PAYMENT_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.PAYMENT_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.PAYMENT_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.PAYMENT_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                    
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.PAYMENT_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.PAYMENT_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
                                    
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        'name': 'Payment | OhMyFood',
                        'description': 'Securely complete your food order payment on OMF using trusted methods like UPI, cards, and wallets.',
                        'url': 'https://omyfood.io/payment',
                        'breadcrumb': {
                            '@type': 'BreadcrumbList',
                            'itemListElement': [
                                {
                                    '@type': 'ListItem',
                                    'position': 1,
                                    'name': 'Home',
                                    'item': 'https://omyfood.io'
                                },
                                {
                                    '@type': 'ListItem',
                                    'position': 2,
                                    'name': 'Cart',
                                    'item': 'https://omyfood.io/cart'
                                },
                                {
                                    '@type': 'ListItem',
                                    'position': 3,
                                    'name': 'Payment',
                                    'item': 'https://omyfood.io/payment'
                                }
                            ]
                        }
                    },)}
                </script>
            </Helmet>

            <div className="topmenubar">
                <SideMenuBar />
                <div className="top-bar-mobile">
                    <TopMenuBar goBackCart={goBack}/>
                </div>
            </div>

            <div className="payment-main-container">
                <div className='cart-box'>   
                    <BackButton style={{width:'100%', marginBottom:'20px'}}/>
                    <div className="apply-coupon-container">
                        <div className="add-ons-title" style={{margin:'0'}}>Apply Coupon</div>
                        <div className="add-ons-line"></div>

                        <CouponCodeInput
                            coupons={coupons}
                            setSelectedCoupon={setSelectedCoupon}
                            setSelectedCouponAmount={setSelectedCouponAmount}
                            setSelectedOffer={setSelectedOffer}
                            userId={decodedToken?.id}   
                            vendorId={vendorID}
                            selectedCoupon={selectedCoupon}
                            setSelectedOfferPercentage={setSelectedOfferPercentage} 
                            selectedOffer={selectedOffer}
                            price={totalPrice}
                        />

                        <div className="coupon-bg" onClick={handleOpen}>
                            <img src={whiteRound} alt="whiteRound" className='white-round-left' />
                            <div className="text-and-svg">
                                <img src={viewCouponImage} alt="viewCouponImage" />
                                <p className="apply-coupon-text">
                                    {selectedOffer
                                        ? selectedOffer.length > 30
                                            ? `${selectedOffer.slice(0, 30)}...`
                                            : selectedOffer
                                        : 'View Coupons & Offers'}
                                </p>
                            </div>
                            <img src={whiteRound} alt="whiteRound" className='white-round-right' />

                            <div className='right-arrow-and-remove-btn'>
                                {selectedOffer && (
                                    <CloseIcon
                                        className="remove-btn"
                                        onClick={handleRemoveCoupon} />
                                )}

                                <RightArrow
                                    color='#333333'
                                    width='10'
                                    height='100%'
                                />
                            </div>

                        </div>
                        {discountError && (
                            <span className="discount-error-message">
                                Discount amount cannot exceed the total price.
                            </span>
                        )}
                    </div>  
                        
                    {open && (
                        <CouponModal
                            open={open}
                            handleClose={handleClose}
                            vendorId={vendorID}
                            setSelectedCoupon={setSelectedCoupon}
                            setSelectedOffer={setSelectedOffer}
                            setSelectedOfferPercentage={setSelectedOfferPercentage}
                            selectedCouponAmount={selectedCouponAmount}
                            setSelectedCouponAmount={setSelectedCouponAmount}
                            setCouponID={setCouponID}
                            setOffersID={setOffersID}
                            setCouponsID={setCouponsID}
                            price={totalPrice}
                        />
                    )}

                    <div className="bill-container">
                        <div className="bill-bg">
                            {loading || !showData ? 
                                (
                                    <div className="price-saving-loader">
                                        <CircularProgress/>
                                    </div>
                                ) : (
                                    <div className="price-saving-total-container">
                                        <div className="price-saving-total">
                                            <div className="price-container">
                                                <h4 className="price-text">{t('payment.sub-total')}</h4>
                                                <p className="price-text">${taxOtherFees?.originalSubtotal?.toFixed(2)}</p>
                                            </div>        

                                            {discountAmount > 0 && (
                                                <div className="price-container">
                                                    <h4 className="price-text">{discountLabel}</h4>
                                                    <p className="price-text">- ${taxOtherFees?.discountAmount?.toFixed(2)}</p>
                                                </div>
                                            )}

                                            
                                            <div className="price-container">
                                                <h4 className="price-text">{t('payment.taxes-other-fees')}</h4>
                                                <p className="price-text">+ ${taxOtherFees?.taxesAndOtherFees}</p>
                                            </div>

                                            {selectedOption === 'delivery' && (
                                                <div className="price-container">
                                                    <h4 className="price-text">{t('payment.delivery-charges')}</h4>
                                                    <p className="price-text">+ ${taxOtherFees?.deliveryFee}</p>
                                                </div>
                                            )}  
                                        </div>

                                        <div className="horizantal-line1"></div>

                                        <div className="total-container">
                                            <h4 className="total-price-text">
                                                {t('payment.total')} : ${taxOtherFees?.finalAmount}
                                            </h4>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>

                    <div className="payment-form-component-container">
                        <Elements stripe={stripePromise}>
                            <PaymentForm 
                                couponID={couponID} 
                                couponsID={couponsID}  
                                offersID={offersID} 
                                cookingInstructionValue=  {cookingInstructionValue} 
                                deliveryInstructionValue={deliveryInstructionValue}
                                disabled={discountError}
                                selectedCoupon={selectedCoupon}
                                discount={discountAmount}
                                selectedOption={selectedOption}
                                selectedAddress={selectedAddress}
                                vendorAddress={vendorAddress}
                                total={totalPrice}
                                taxAmount={taxOtherFees?.taxAmount}
                                platFormFee={taxOtherFees?.platformFee}
                                deliveryInfo={taxOtherFees?.deliveryInfo}
                                finalAmount={taxOtherFees?.finalAmount}
                                taxesAndOtherfees={taxOtherFees?.taxesAndOtherFees}
                                deliveryFee={taxOtherFees?.deliveryFee}
                            />
                        </Elements>
                    </div>
                </div>
            </div>

            <div className="right-side-bar">
                <RightSideBar />
            </div>
        </div>
    );
}

export default Payment;
